import { Component, Inject, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AccoountingOrganization, AccountingResource, AccountingSettings, AccountingSystemDetails, SettingsResource } from '@apaq/orgkit-js';
import { ContextService } from 'ngx-orgkit';
import { DialogRef } from 'src/app/modules/dialog/dialog-ref';
import { DATA, DIALOG } from 'src/app/modules/dialog/dialog.service';
import { ConnectDetails } from '../../accounting-view.component';

declare var window: Window & {
  __orgkit__: {
    host: string
  }
};

@Component({
  selector: 'app-dinero-connection-dialog',
  templateUrl: './dinero-connection-dialog.component.html',
  styleUrls: ['./dinero-connection-dialog.component.scss']
})
export class DineroConnectionDialogComponent implements OnInit {

  systemId: string = '';
  systemKey: string = '';
  redirectUri: string;
  clientId = 'isv_previsto';
  authUrl: string;
  popup?: Window | null;
  awaitingPopup = true;
  remoteOrgs?: AccoountingOrganization[];

  constructor(@Inject(DIALOG) private dialog: DialogRef,
    protected _sanitizer: DomSanitizer, 
    private context: ContextService,
    @Inject(DATA) private data: ConnectDetails,
    private accountingResource: AccountingResource,
    private settingsResource: SettingsResource) {
      this.redirectUri = `${window.__orgkit__?.host}/callbacks/vismaDineroConnect`;

      // Beware: Visma Connect does not allow localhost. Change it to 127.0.0.1.
      this.redirectUri = this.redirectUri.replace('localhost', '127.0.0.1');

      this.authUrl =  `https://connect.visma.com/connect/authorize?state=${context.organizationId}&client_id=${this.clientId}&response_mode=query&response_type=code&scope=dineropublicapi:read+dineropublicapi:write+offline_access&redirect_uri=${this.redirectUri}&ui_locales=da-DK`

      
  }

  ngOnInit(): void {
    this.systemId = this.data?.systemId;
    this.popup = window.open(this.authUrl, '_blank', 'width=560,height=800');
    this.whenPopupClosed().then( async ()=> {
      const settings = await this.settingsResource.findById('accounting') as AccountingSettings;
      this.systemKey = settings.systemKey;

      if(this.systemId == null) {
        this.remoteOrgs = await this.accountingResource.listAccessibleOrganizations();
        if(this.remoteOrgs.length > 0) {
          this.systemId = this.remoteOrgs[0].id;
        }
        this.awaitingPopup = false;
      } else {
        this.connect();
      }
      
    });
  }

  close() {
    this.dialog.close();
  }

  async connect() {
    const details: AccountingSystemDetails = { id: this.systemId!, key: this.systemKey!, system: 'Dinero' };
    try {
      await this.accountingResource.checkAccountingBackend(details);
    } catch (error) {
      Stallion.alert($localize`Cannot connect to Dinero with the specified company id and api key.`, 'warning');
      return;
    }
    this.dialog.close(details);
  }

  whenPopupClosed(): Promise<void> {
    const promise = new Promise<void>(resolve => {
      const interval = setInterval(() => {
        if(this.popup?.closed) {
          clearInterval(interval);
          resolve();
        }
      }, 50);
    });
    return promise;
  }
}
